<script lang="ts">
    import {
        Card,
        CardTitle,
        CardText,
        Divider,
        ListItem,
        ProgressCircular,
    } from "svelte-materialify/src";
    import { Collection } from "sveltefire";
</script>

<Card outlined>
    <CardTitle class="remove-break">My Interests</CardTitle>
    <Divider />
    <Collection
        path={"interests"}
        traceId={"interestsRead"}
        let:data={interests}
        query={(ref) => ref.orderBy("order", "asc")}
    >
        {#each interests as { summary }, i}
            <ListItem style="color: var(--theme-text-secondary)">
                <span slot="default" class="block-wrap remove-break"
                    >{summary}</span
                >
            </ListItem>
            {#if i + 1 < interests.length}
                <Divider />
            {/if}
        {/each}
        <span slot="loading">
            <ProgressCircular indeterminate color="primary" /></span
        >
        <span slot="fallback">Error loading data</span>
    </Collection>
</Card>
